<template>
  <div class="tripRight">
    <div>
      <div class="stockDiv">
        <hotel-stock v-show="checkIndex==0" :stockTypeObj="stockTypes[0]" :checkState="stockTypes[checkIndex].state" ref="hotel" ></hotel-stock>
        <site-stock v-show="checkIndex==1" :stockTypeObj="stockTypes[1]" :checkState="stockTypes[checkIndex].state" ref="site"></site-stock>
        <spot-stock v-show="checkIndex==2" :stockTypeObj="stockTypes[2]" :checkState="stockTypes[checkIndex].state" ref="spot" ></spot-stock>
        <traffic-stock v-show="checkIndex==3" :stockTypeObj="stockTypes[3]" :checkState="stockTypes[checkIndex].state" ref="traffic"></traffic-stock>
        <big-traffic v-show="checkIndex==4"></big-traffic>
        <meal-stock v-show="checkIndex==5" :stockTypeObj="stockTypes[5]" :checkState="stockTypes[checkIndex].state" ref="meal"></meal-stock>
        <guide-stock v-show="checkIndex==6" :stockTypeObj="stockTypes[6]" :checkState="stockTypes[checkIndex].state" ref="guide"></guide-stock>
        <visa-stock  v-show="checkIndex==7" :stockTypeObj="stockTypes[7]" :checkState="stockTypes[checkIndex].state" ref="visa"></visa-stock>
        <affair-stock v-show="checkIndex==8" :stockTypeObj="stockTypes[8]" :checkState="stockTypes[checkIndex].state" ref="affairs"></affair-stock>
        <experience-stock v-show="checkIndex==9" :stockTypeObj="stockTypes[9]" :checkState="stockTypes[checkIndex].state" ref="experience"></experience-stock>
        <business-stock v-show="checkIndex==10" :stockTypeObj="stockTypes[10]" :checkState="stockTypes[checkIndex].state" ref="business"></business-stock>
      </div>
      <div class="typeDiv">
        <div class="typeDivD">
          <div>
            <div v-for="(item,index) in stockTypes" :key="index" :class="index==checkIndex?'chenckClass':''" @click="changeType(index)">{{item.typeName}}</div>
          </div>
          <div>
            <div>
              <p>整团</p>
              <p>询价</p>
            </div>
            <div @click="addPlanProductInquiry">
              <p>项目</p>
              <p>询价</p>
            </div>
            <div @click="addFastBudget">
              <p>快速</p>
              <p>添加</p>
            </div>
            <div>
              <p>智能</p>
              <p>推荐</p>
            </div>
            <div>
              <p>只看</p>
              <p>喜欢</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <plan-product-inquiry-dialog ref="planProductInquiry"></plan-product-inquiry-dialog>
    <add-fast-budget ref="addFastBudget"></add-fast-budget>
  </div>
</template>
<script>
import AffairStock from './stockPage/affairStock.vue'
import BigTraffic from './stockPage/bigTraffic.vue'
import businessStock from './stockPage/businessStock.vue'
import experienceStock from './stockPage/experienceStock.vue'
import guideStock from './stockPage/guideStock.vue'
import hotelStock from './stockPage/hotelStock.vue'
import mealStock from './stockPage/mealStock.vue'
import SiteStock from './stockPage/siteStock.vue'
import SpotStock from './stockPage/spotStock.vue'
import TrafficStock from './stockPage/trafficStock.vue'
import VisaStock from './stockPage/visaStock.vue'
import { planHeight } from '@/assets/utils/PlanHeight'
import PlanProductInquiryDialog from '../../inquiry/planProductInquiryDialog.vue'
import addFastBudget from './dialog/addFastBudget.vue'
export default {
  components: { hotelStock ,SpotStock, TrafficStock, mealStock, guideStock, SiteStock,VisaStock,AffairStock,experienceStock,businessStock,
    BigTraffic,PlanProductInquiryDialog,addFastBudget},
  data(){
    return{
      stockDivHeight: {
        height: 0
      },  
      stockTypes:[{
        'typeName':'酒店',
        'state':0,
        'typeNameSimple':'住',
        'typeNameCity':'住宿地点',
        'typeNameEn':'hotel'
      },{
        'typeName':'会议',
        'state':1,
        'typeNameSimple':'会',
        'typeNameCity':'会议城市',
        'typeNameEn':'site'
      },{
        'typeName':'景点',
        'state':2,
        'typeNameSimple':'景',
        'typeNameCity':'景点地点',
        'typeNameEn':'spot'
      },{
        'typeName':'用车',
        'state':3,
        'typeNameSimple':'车',
        'typeNameCity':'用车区域',
        'typeNameEn':'traffic'
      },{
        'typeName':'交通',
        'state':11,
        'typeNameEn':'bigTraffic'
      },{
        'typeName':'用餐',
        'state':4,
        'typeNameSimple':'餐',
        'typeNameCity':'餐厅地址',
        'typeNameEn':'meal'
      },{
        'typeName':'人员',
        'state':5,
        'typeNameSimple':'导',
        'typeNameCity':'导游区域',
        'typeNameEn':'guide'
      },{
        'typeName':'签证',
        'state':6,
        'typeNameSimple':'签',
        'typeNameCity':'签证国家',
        'typeNameEn':'visa'
      },{
        'typeName':'公务',
        'state':10,
        'typeNameSimple':'公',
        'typeNameCity':'公务城市',
        'typeNameEn':'affairs'
      },{
        'typeName':'体验',
        'state':8,
        'typeNameSimple':'体',
        'typeNameCity':'体验城市',
        'typeNameEn':'experience'
      },{
        'typeName':'商务',
        'state':7,
        'typeNameSimple':'商',
        'typeNameCity':'商务城市',
        'typeNameEn':'business'
      }],
      checkIndex:0,
    }
  },
  methods:{
    addFastBudget(){
      this.$refs.addFastBudget.openBefore()
    },
    changeType(index,keyword){
      this.checkIndex = index
      this.$nextTick(()=>{
        if(this.checkIndex!=4){
          this.$refs[this.stockTypes[this.checkIndex].typeNameEn].$refs.stock.postListData('empty')
          if(keyword){
            this.$refs[this.stockTypes[this.checkIndex].typeNameEn].$refs.stock.searchObj.keyword = keyword
          }
        }
        planHeight()
      })
    },
    addPlanProductInquiry(){
      this.$refs.planProductInquiry.beforeOpen();
    }
  },
  mounted(){
    this.$Bus.$on('addStockMore',data=>{
      var index = this.stockTypes.findIndex(e=>e.state===data.state)
      this.changeType(index,data.resourceNameCn)
    })
    this.$Bus.$on('openInquiryPage',data=>{
      this.$refs.planProductInquiry.beforeOpen(data);
    })
  },
  beforeDestroy(){
    this.$Bus.$off("addStockMore");
    this.$Bus.$off("openInquiryPage");
  },
}
</script>

<style lang="scss" scoped>
.tripRight{
  .stockDiv{
    width: 7.3rem;
    position: absolute;
    top: 1rem;
    left: 10.7rem;
    bottom: 0.02rem;
    background-color: white;
  }
  .typeDiv{
    width: 0.4rem;
    position: absolute;
    top: 1rem;
    left: 18.1rem;
    bottom: 0.02rem;
    .chenckClass{
      background: var(--bottomBtnColor);
      color: white !important;
    }
    .typeDivD{
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      >div:first-child{
        >div{
          color:var(--bottomBtnColor) ;
          text-align: center;
          height: 0.4rem;
          line-height: 0.4rem;
          margin-bottom: 0.08rem;
          border: 1px solid var(--bottomBtnColor);
        }
      }
      >div:last-child{
        >div{
          cursor: pointer;
          text-align: center;
          background: var(--bottomBtnColor);
          color: #fff;
          min-height: 0.4rem;
          margin-bottom: 0.05rem;
          border: 1px solid #02a0c6;
          font-size: 0.12rem;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
      }
    }
  }
}
</style>